'use strict';

var getSomethingById = function getSomethingById(things, id) {
    var comparatorKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
    return things.find(function (thing) {
        return thing[comparatorKey] === id;
    });
};

//if item is checked, push that item into the selections array
//otherwise, find the element in the selections array that has this item's id
//and remove it
var performAddOrRemoveSelection = function performAddOrRemoveSelection(selections, id, availableSelections, adding) {
    if (adding) {
        if (!selections.find(function (selection) {
            return selection.id === id;
        })) {
            selections.push(availableSelections.find(function (el) {
                return el.id === id;
            }));
        }
        return selections;
    } else {
        return selections.filter(function (el) {
            return el.id !== id;
        });
    }
};

// use the reduce function to loop over every object in an object array and or the keyToOr values with each other
// if any values are true, then we return true
var orAllValuesOfObjectsByKey = function orAllValuesOfObjectsByKey(objects, keyToOr) {
    return Object.keys(objects).reduce(function (acc, objectKey) {
        return objects[objectKey][keyToOr] || acc;
    }, false);
};

var andAllValuesOfObjectsByKey = function andAllValuesOfObjectsByKey(objects, keyToAnd) {
    return Object.keys(objects).reduce(function (acc, objectKey) {
        return objects[objectKey][keyToAnd] && acc;
    }, true);
};

var groupDataBy = function groupDataBy(data, groupKey, defaultGroupValue) {
    var groupedData = {};

    data.forEach(function (datum) {
        var groupName = datum[groupKey] || defaultGroupValue;

        if (!groupedData[groupName]) {
            groupedData[groupName] = [];
        }

        groupedData[groupName].push(datum);
    });

    return groupedData;
};

var arrayEquals = function arrayEquals(arr1, arr2) {
    return arr1.length !== arr2.length ? false : arr1.every(function (arr1Item) {
        return arr2.includes(arr1Item);
    });
};

var valuesInObjectArrayToDelimitedList = function valuesInObjectArrayToDelimitedList(objectArray, delimiter) {
    for (var _len = arguments.length, keys = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        keys[_key - 2] = arguments[_key];
    }

    return objectArray.reduce(function (acc, object) {
        var value = object;
        keys.forEach(function (key) {
            return value = value[key];
        });

        if (acc === '') {
            return value;
        }
        return '' + acc + delimiter + value;
    }, '');
};

var runFunctionOrGetValue = function runFunctionOrGetValue(functionOrValue, param) {
    return typeof functionOrValue === 'function' ? functionOrValue(param) : functionOrValue;
};

var index = {
    getSomethingById: getSomethingById,
    performAddOrRemoveSelection: performAddOrRemoveSelection,
    orAllValuesOfObjectsByKey: orAllValuesOfObjectsByKey,
    andAllValuesOfObjectsByKey: andAllValuesOfObjectsByKey,
    groupDataBy: groupDataBy,
    arrayEquals: arrayEquals,
    valuesInObjectArrayToDelimitedList: valuesInObjectArrayToDelimitedList,
    runFunctionOrGetValue: runFunctionOrGetValue
};

module.exports = index;
